import {categoryDetails as categoryA} from "./1";
import {categoryDetails as categoryB} from "./2";

const contentObject = {[categoryA.id]: categoryA, [categoryB.id]: categoryB}

export default contentObject;
